<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <h1>{{ $t("bi.powerbiview.edit") }}</h1>
        <success-fade-alert ref="alert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

        <b-row class="mb-3 ml-0">
          <router-link :to="'../../bi/' + companyId.toString()">
            <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
          </router-link>
        </b-row>

        <crud-data
          :model="model"
          :modelstate="modelstate"
          class="mb-4"
        ></crud-data>

        <b-button class="button" @click="save" :disabled="submitted">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "PowerBIViewEdit",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CrudData: () =>
      import("@/components_rms/BI/PowerBIView/PowerBIViewCrudData.vue"),
  },
  props: {
    id: String,
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        id: 0,
        displayName: "",
        bi: false,
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.$apiScheduler
        .get(
          "/powerbiview/get/" +
            this.id.toString() +
            "/" +
            this.companyId.toString()
        )
        .then((response) => {
          this.model = response.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error;
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0, 0);
          }
        });
    },
    save() {
      this.submitted = true;
      this.$apiScheduler
        .post("/powerbiview/edit/" + this.model.id.toString(), this.model)
        .then((response) => {
          if (response.data.success) {
            this.model = response.data.data;
            this.$refs.alert.show();
            this.modelstate = {};
            window.scrollTo(0, 0);
          } else {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0, 0);
          }
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
            }
          }
          this.alert.error = error.message;
          this.$refs.fadeAlertDanger.show();
          window.scrollTo(0, 0);
        });
    },
  },
};
</script>
